import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { TYPE_DATE_PICKER } from 'utils/constants/sportsbook/results';
import { showToastError } from 'utils/generic/show-toast-error';
import { ResultsSport } from 'interfaces/results';
import { getActiveCompetitions } from 'services/sportsbook/results';
import { setData, setDataLoading } from 'store/actions/results-data';
import { getResultsActiveDate } from 'store/selectors/results-data';

export const useGetActiveCompetitions = (
  sportTypeId: string | undefined | null
): void => {
  const dispatch = useDispatch();
  const activeDate = useSelector(getResultsActiveDate);

  useEffect(() => {
    dispatch(setDataLoading(true));
    getActiveCompetitions(
      dayjs(activeDate[TYPE_DATE_PICKER ? 'from' : 'to'])
        .startOf('day')
        .unix(),
      dayjs(activeDate.to).endOf('day').unix(),
      (data: { details: ResultsSport[] }) => {
        dispatch(setData(data.details));
        dispatch(setDataLoading(false));
      },
      (error: { data: { result_text: string; result: string } }) => {
        dispatch(setData([]));
        dispatch(setDataLoading(false));
        showToastError(error.data.result_text);
      },
      sportTypeId
    );
  }, [activeDate, sportTypeId]);
};
